export default "__VITE_ASSET__BmmI9tz6__"